import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of, take } from 'rxjs';
import { BackofficeAccessService } from '../../shared/components/sidebar/sidebar.service';

export const accessGuard: CanActivateFn = (route) => {
  const access = inject(BackofficeAccessService);
  const router = inject(Router);
  const moduleKey = route.data['moduleKey'] as string | undefined;

  if (!moduleKey) return true;

  if (access.accessLoaded()) {
    return access.hasModule(moduleKey);
  }

  return access.loadAccess().pipe(
    take(1),
    map(() => access.hasModule(moduleKey) ? true : router.createUrlTree(['/sin-acceso'])),
    catchError(() => of(router.createUrlTree(['/sin-acceso']))),
  );
};
